import * as types from '../actions/_actionTypes';
import initialState from './_initialReducerState'

export default function DftypesReducer(state = initialState.dftypes, action: any) {
  switch (action.type) {
    case types.SAVE_DFTYPES_SUCCESS:
      return action.dftypes;
    default:
      return state;
  }
}
